module.exports = __webpack_public_path__ + "img/aParty_032523_B.a8443b2e.jpg";